import { shallowRef } from "vue";
/**
 * React의 useState와 유사한 Vue 3 컴포저블
 * @param initialState 초기 상태값
 * @returns [state, setState] 튜플
 */
export function useState(initialState) {
    // 초기값이 함수인 경우 실행하여 값을 얻음
    const initialValue = typeof initialState === "function"
        ? initialState()
        : initialState;
    const state = shallowRef(initialValue);
    const setState = (newState) => {
        if (typeof newState === "function") {
            // 함수인 경우 이전 상태를 인자로 받아 새로운 상태를 반환
            state.value = newState(state.value);
        }
        else {
            // 값인 경우 직접 할당
            state.value = newState;
        }
    };
    return [state, setState];
}
export function useStateWithType(initialState) {
    return useState(initialState);
}
